import React, { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Form, Select } from 'antd'
import { map } from 'lodash-es'
import {
  createUrl,
  getQueryParams,
} from '../../../../core/utils/services/queryParams'
import { SCRAPING_TYPES } from '../../../constants'

const style = {
  width: '100%',
}

const ScrapingTypeFilter = () => {
  const history = useHistory()
  const { pathname, search } = useLocation()

  const { scrapingType } = getQueryParams(search)

  const handleChange = useCallback(
    scrapingType =>
      history.push(
        createUrl(pathname, search, {
          scrapingType,
        }),
      ),
    [history, pathname, search],
  )

  return (
    <Form.Item label="Scraping Type" labelCol={{ span: 24 }}>
      <Select
        style={style}
        allowClear
        value={scrapingType}
        onChange={handleChange}
      >
        {map(SCRAPING_TYPES, ({ name, value }) => (
          <Select.Option key={value} value={value}>
            {name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

export default ScrapingTypeFilter
